import React, { useState } from 'react';
import './Mensajeria.css';

const Mensajeria = () => {
  const phoneNumber = "525623688854";
  const [nombre, setNombre] = useState('');
  const [mensaje, setMensaje] = useState('');

  const handleWhatsApp = () => {
    const text = nombre
      ? `Hola, soy ${nombre}. ${mensaje || 'Requiero ayuda.'}`
      : mensaje || 'Hola, requiero ayuda!';
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`, '_blank');
  };

  return (
    <div className="contact-page">
      <div className="contact-container">

        <div className="contact-hero">
          <h1>¿Necesitas ayuda?</h1>
          <p>Estamos aquí para ti. Escríbenos por el canal que prefieras.</p>
        </div>

        {/* WhatsApp */}
        <div className="contact-card">
          <div className="contact-card-header">
            <div className="contact-card-icon whatsapp">💬</div>
            <div>
              <p className="contact-card-title">WhatsApp</p>
              <p className="contact-card-sub">Respuesta en minutos</p>
            </div>
          </div>
          <div className="contact-form">
            <input
              className="contact-input"
              type="text"
              placeholder="Tu nombre (opcional)"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
            <textarea
              className="contact-input"
              placeholder="¿En qué podemos ayudarte?"
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
            />
            <button className="contact-wa-btn" onClick={handleWhatsApp}>
              Enviar por WhatsApp
            </button>
          </div>
        </div>

        {/* Email */}
        <div className="contact-card">
          <div className="contact-card-header">
            <div className="contact-card-icon email">📧</div>
            <div>
              <p className="contact-card-title">Correo electrónico</p>
              <p className="contact-card-sub">Te respondemos en 24 hrs</p>
            </div>
          </div>
          <a href="mailto:soporte@monkeyphone.net" className="contact-email-link">
            soporte@monkeyphone.net
          </a>
        </div>

        {/* Horario */}
        <div className="contact-card">
          <div className="contact-card-header">
            <div className="contact-card-icon hours">🕐</div>
            <div>
              <p className="contact-card-title">Horario de atención</p>
              <p className="contact-card-sub">Zona horaria CDMX</p>
            </div>
          </div>
          <div className="contact-hours">
            <span>Lunes a Viernes</span>
            <span>9:00 - 18:00</span>
          </div>
          <div className="contact-hours">
            <span>Sábado</span>
            <span>10:00 - 14:00</span>
          </div>
          <div className="contact-hours">
            <span>Domingo</span>
            <span>10:00 - 14:00</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Mensajeria;
